module.exports = __webpack_public_path__ + "static/undraw_wireframing_nxyi-58df8628389853c85b1b52ee0a7db424.svg";